import { Skeleton } from "@/components/ui/skeleton";
import { GraficoLinhas } from "../GraficoLinhas";
import { useInteracoesPorMes } from "../api";
import { detalheVariacao, formatInteiro, formatNumero, mesAtualEVariacao, seriesInteracoes, TIPOS_CS } from "../series";
import { Interacoes } from "./Interacoes";
import { GradeKpis, Kpi, type Variante } from "./Kpi";

/** Interações do mês por tipo e o histórico mensal. Na TV, as últimas vão na coluna lateral. */
export function TelaCs({ variante }: { variante: Variante }) {
  const tv = variante === "tv";
  const interacoes = useInteracoesPorMes({ autoAtualizar: tv });
  const series = seriesInteracoes(interacoes.data);

  const grafico = series ? (
    <GraficoLinhas titulo="Interações por mês" {...series} formatValor={formatInteiro} variante={variante} />
  ) : (
    <Skeleton className={tv ? "h-full w-full rounded-xl bg-white/10" : "h-[22rem] w-full rounded-xl"} />
  );

  return (
    <div className={tv ? "flex h-full flex-col gap-8" : "space-y-4"}>
      <GradeKpis variante={variante} colunas={4}>
        {TIPOS_CS.map(({ tipo, label, cor }) => {
          const { atual, variacao } = mesAtualEVariacao(interacoes.data?.series[tipo]);
          return (
            <Kpi
              key={tipo}
              rotulo={`${label} no mês`}
              valor={formatNumero(atual)}
              isLoading={interacoes.isLoading}
              variante={variante}
              cor={cor}
              detalhe={detalheVariacao(variacao, "vs mês passado")}
            />
          );
        })}
      </GradeKpis>
      {tv ? (
        <div className="min-h-0 flex-1">{grafico}</div>
      ) : (
        <div className="grid gap-4 lg:grid-cols-3">
          <div className="lg:col-span-2">{grafico}</div>
          <Interacoes />
        </div>
      )}
    </div>
  );
}
